import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import TextInfo, {
  TEXT_INFO_KIND,
  TEXT_INFO_COLOR,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_HEADING_LEVEL,
} from '@gcloud-npm/next12.components.text-info-n';
import { SendSondaComponentNotShown } from '@/utils/functions';

import Picture from '@gcloud-npm/next12.components.picture';
import Price, {
  PRICE_FONT_TYPE,
  PRICE_COLORS,
  PRICE_DECORATION,
  PRICE_SIZE,
} from '@gcloud-npm/next12.components.price';
import styles from './styles';
import { GetBandaPromoOrInfo, GetButton, GetCtaButtonClassName } from './utils';

export const ModuloBanner = (props) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!props || !props.data) {
      const componentName = 'ModuloBanner';
      SendSondaComponentNotShown(componentName, dispatch);
      return null;
    }
  }, []);
  const { data, taggingInfo, className } = props;
  const { cta, imgDeskFicha, imgMobile, customClickEvent } = data;
  const componentName = 'ModuloBannerFicha';

  const btnTaggingInfo = {
    ...taggingInfo,
    componentContent: cta?.btnText || '',
    componentName,
  };
  return (
    <div className={`moduloBanner ${className || ''}`}>
      {imgMobile && (
        <Picture
          sources={[{ src: imgMobile }]}
          alt={cta?.nombre || ''}
          className="imgBanner imgMobile"
        />
      )}
      {imgDeskFicha && (
        <Picture
          sources={[{ src: imgDeskFicha }]}
          alt={cta?.nombre || ''}
          className="imgBanner imgDesktop"
        />
      )}
      <div className="container display-end">
        {cta && (
          <div
            className={`cta ${cta.customClassName ? cta.customClassName : ''}`}
          >
            {cta.nombreComercial && (
              <TextInfo
                text={cta.nombreComercial}
                kind={TEXT_INFO_KIND.SPAN}
                color={TEXT_INFO_COLOR.BLUE_DARK}
                size={
                  props.type === 'TYPE2'
                    ? TEXT_INFO_SIZE.TITLE3
                    : TEXT_INFO_SIZE.CAPTION1
                }
                fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                className="ctaNombreComercial"
              />
            )}
            {cta.nombre && (
              <TextInfo
                className="nombre"
                text={cta.nombre}
                level={TEXT_INFO_HEADING_LEVEL.H1}
                kind={TEXT_INFO_KIND.HEADING}
                color={TEXT_INFO_COLOR.BLUE_DARK}
                size={
                  props.type === 'TYPE2'
                    ? TEXT_INFO_SIZE.TITLE6
                    : TEXT_INFO_SIZE.TITLE3
                }
                fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
              />
            )}
            {cta.description && (
              <TextInfo
                className="description"
                text={cta.description}
                color={TEXT_INFO_COLOR.GREY_5}
                size={TEXT_INFO_SIZE.TITLE6}
              />
            )}
            <div className="pricesContainer">
              {GetBandaPromoOrInfo(cta.bandaInfo, cta.bandaPromo)}
              <div className="prices">
                {cta.textPrice && (
                  <TextInfo
                    text={cta.textPrice}
                    kind={TEXT_INFO_KIND.SPAN}
                    color={TEXT_INFO_COLOR.GREY_4}
                    size={TEXT_INFO_SIZE.CAPTION1}
                    fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                  />
                )}

                {cta.pvpTachado !== undefined &&
                  cta.pvpTachado !== cta.price && (
                    <div className="pvpTachado">
                      <Price
                        amount={cta.pvpTachado}
                        decoration={PRICE_DECORATION.LINE_THROUGH}
                        size={PRICE_SIZE.EMP_22}
                        color={PRICE_COLORS.GREY_4}
                        withSpace={false}
                        unity={cta?.priceUnity || '€'}
                      />
                    </div>
                  )}
                {cta.price >= 0 && (
                  <div className="price">
                    <Price
                      amount={cta.price < 0 ? 0 : cta.price}
                      decoration={PRICE_DECORATION.NONE}
                      size={PRICE_SIZE.TITLE4}
                      unity={cta?.priceUnity || '€/mes'}
                      withSpace={false}
                      color={PRICE_COLORS.BLUE_DARK}
                      fontType={PRICE_FONT_TYPE.BOLD}
                      ty
                    />
                  </div>
                )}

                {cta.textDisponibilidad &&
                  cta.textDisponibilidad.length > 0 && (
                    <TextInfo
                      text={cta.textDisponibilidad}
                      kind={TEXT_INFO_KIND.SPAN}
                      color={TEXT_INFO_COLOR.BLUE_DARK1}
                      size={TEXT_INFO_SIZE.CAPTION1}
                      className="ctaTextDisponibilidad"
                    />
                  )}
              </div>
            </div>
            {cta.textUnderPrice && (
              <TextInfo
                text={cta.textUnderPrice}
                kind={TEXT_INFO_KIND.SPAN}
                color={TEXT_INFO_COLOR.BLUE_DARK}
                size={TEXT_INFO_SIZE.CAPTION2}
                fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                className="ctaTextUnderPrice"
              />
            )}
            {cta.btnText && (
              <div className={GetCtaButtonClassName(cta)}>
                {GetButton(cta, customClickEvent, btnTaggingInfo)}
              </div>
            )}
            {cta.textPrecontrato && cta.pdfPrecontrato && (
              <div className="contractDetails">
                <CustomLink
                  href={cta.pdfPrecontrato}
                  title={cta.textPrecontrato}
                  taggingInfo={btnTaggingInfo}
                  ariaLabel={cta.textPrecontrato}
                  target="_blank"
                  forceExternal
                >
                  <TextInfo
                    text={cta.textPrecontrato}
                    kind={TEXT_INFO_KIND.SPAN}
                    color={TEXT_INFO_COLOR.BLUE}
                    size={TEXT_INFO_SIZE.CAPTION1}
                    fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                  />
                </CustomLink>
              </div>
            )}
            {(cta.legalsDescription ||
              (cta.textLegals && (cta.functionLegals || cta.hrefLegals))) && (
              <div className="moduloBanner_legals">
                {cta.legalsDescription && (
                  <div>
                    <TextInfo
                      text={cta.legalsDescription}
                      kind={TEXT_INFO_KIND.SPAN}
                      color={TEXT_INFO_COLOR.GREY_5}
                      size={TEXT_INFO_SIZE.TITLE6}
                      className="ctaDescription"
                    />
                  </div>
                )}
                {cta.textLegals && (cta.functionLegals || cta.hrefLegals) && (
                  <div className="contractDetails">
                    <CustomLink
                      href={cta.hrefLegals}
                      onClick={cta.functionLegals}
                      title={cta.textLegals}
                      taggingInfo={{
                        ...btnTaggingInfo,
                        componentContent: cta.textLegals,
                      }}
                      ariaLabel={cta.textLegals}
                      target="_blank"
                      forceExternal
                    >
                      <TextInfo
                        text={cta.textLegals}
                        kind={TEXT_INFO_KIND.SPAN}
                        color={TEXT_INFO_COLOR.BLUE}
                        size={TEXT_INFO_SIZE.CAPTION2}
                        fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                      />
                    </CustomLink>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};
export default ModuloBanner;
ModuloBanner.propTypes = {
  data: PropTypes.shape({
    cta: PropTypes.shape({
      nombre: PropTypes.string,
      nombreComercial: PropTypes.string,
      btnText: PropTypes.string,
      urlButton: PropTypes.string,
      textPrecontrato: PropTypes.string,
      pdfPrecontrato: PropTypes.string,
      bandaInfo: PropTypes.string,
      description: PropTypes.string,
      textDisponibilidad: PropTypes.string,
      textPrice: PropTypes.string,
      textUnderPrice: PropTypes.string,
      bandaPromo: PropTypes.string,
      price: PropTypes.number,
      pvpTachado: PropTypes.number,
      activationRule: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
      }),
    }),
    imgMobile: PropTypes.string,
    imgDeskFicha: PropTypes.string,
    customClickEvent: PropTypes.any,
  }),
  taggingInfo: PropTypes.any,
  className: PropTypes.string,
};

ModuloBanner.defaultProps = {
  data: null,
  taggingInfo: null,
  className: '',
};
